import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import { JSX } from 'react';

type TAudiencesStatsCardProps = {
  title: string;
  Icon: JSX.Element;
  value: number | string;
  loading?: boolean;
};

const AudiencesStatsCard = ({ title, Icon, value, loading }: TAudiencesStatsCardProps) => {
  return (
    <Container
      className="flex fd-column"
      width="233px"
      height="82px"
      padding="16px"
      background="var(--global-cont-1)"
      borderRadius="12px"
    >
      <Text className="S2" design="GlobalIcoText3">
        {title}
      </Text>
      <Container className="flex fd-row" height="32px" width="193px">
        <Container height="32px" width="16px" margin="0 6px 0 0" className="flex fd-row jc-center ai-center">
          {Icon}
        </Container>
        <Text
          skeletonLoader={loading}
          skeletonLoaderBackground={{ start: 'transparent', end: 'var(--gray-800)' }}
          tag="h4"
          className="H4"
          width={'100%'}
          color={Number(value) < 0 ? 'var(--gray-400)' : undefined}
          clamp={1}
        >
          {value}
        </Text>
      </Container>
    </Container>
  );
};

export default AudiencesStatsCard;
